export default {
  common: {
    language: '语言',
    logoAlt: '中泽科教',
    cancel: '取消',
  },
  chatService: {
    chatNow: {
      label: '在线咨询',
    },
    emailGate: {
      title: '请先填写邮箱',
      desc: '为便于及时回复，请先填写邮箱后继续咨询。',
      successMessage: '邮箱已提交，现在可以继续咨询。',
    },
  },
  nav: {
    home: '首页',
    products: '产品',
    software: '软件',
    eduServices: '教育服务',
    support: '服务与支持',
    cooperation: '教育合作',
    about: '关于我们',

    // Sub-menus & Mega Menu
    learningPlatform: '中泽科教学习平台',
    cloudPlatform: '中泽科教云平台',
    laserSoftware: '激光设备专用软件',
    makerK12: '科教创客-中小学',
    archVocational: '建筑模型-中职',
    cultHigherVoc: '文创设计-高职',
    artsUni: '艺术与工艺品-高校',
    afterSales: '售后服务',
    faq: '常见问题',
    download: '下载中心',
    companyIntro: '公司简介',
    news: '新闻资讯',
    contact: '联系我们',
    device: '设备',
    kits: '套件',
    softwareService: '软件服务',
    accessories: '配件',
    forMakers: 'For Makers',
    forEducation: 'For Education',
    kitsSystem: '套件体系',
    kitsAccessories: '套件配件',
    courses: '课程',
  },
  aboutPage: {
    seoTitle: '关于我们 - 中泽科教',
    banner: {
      title: '关于我们',
    },
    about: {
      title: '关于我们',
      body: '中泽教育成立于2015年，凭借与香港联通国际的紧密合作，在欧美STEAM课程基础上自主研发适合国内儿童的创客教育体系，通过社会化的学习和实践， 让孩子们跨越极限，创造精彩。我们以“STEAM教育+创客空间”为核心，秉承“培养未来创造者”的使命， 专注于3-16岁少年儿童的科技创造力教育，开设科创教育空间，自主研发科创教育产品与课程， 围绕学习设计软件、激光雕刻、编程等内容板块，形成独特的教育内容研发生态与产品闭环。让孩子们在真实的项目中获得适应未来的核心能力! 我们的愿景是成为国际科创教育的倡导者，我们提供的不仅是课程，创客环境，更是一种全新的学习方式，我们相信每个孩子都是未来的创新者， 让孩子们像科学家一样思考探究，像工程师一样动手实践，像设计师一样创意飞扬，像创客一样学习智造。让他们在探索中发现自我，在实践中成就未来。',
    },
    intro: {
      title: '为什么选择我们？',
      desc: '成为国际科创教育的倡导者，提供课程、创客环境，更是一种全新的学习方式。我们相信每个孩子都是未来的创新者，让他们在探索中发现自我，在实践中成就未来。',
      features: {
        projectLearning:
          '项目式学习：通过项目式学习，让孩子们在真实的项目中获得适应未来的核心能力。',
        interactiveExperiments:
          '互动式实验：通过这些互动式实验，孩子们不仅能掌握基本的科学原理，还能培养解决问题的能力、创造力和团队合作精神。',
      },
    },
    images: {
      aboutAlt: '关于中泽科教',
      featureIcon1Alt: '项目式学习图标',
      featureIcon2Alt: '互动式实验图标',
      introAlt: '为什么选择我们',
    },
  },
  newsPage: {
    banner: {
      title: '新闻资讯',
    },
    tabs: [
      { id: 'all', name: '全部' },
      { id: 'company', name: '公司新闻' },
      { id: 'exhibition', name: '展会动态' },
      { id: 'industry', name: '行业动态' },
    ],
    items: [
      { title: '恒好激光闪耀BETT UK 2025：以激光技术赋能教育创新' },
      { title: 'K12教育创新的核心：CO2激光切割机如何推动STEAM教学' },
      { title: '恒好激光客户携Light 530闪耀 didacta Italia 2025' },
      { title: '中泽科教发布全新智能教育解决方案' },
      { title: '未来教育趋势：人工智能与创客教育的深度融合' },
    ],
  },
  newsInformationPage: {
    banner: {
      title: '新闻资讯',
    },
    tabs: [
      { id: 'all', name: '全部' },
      { id: 'company', name: '公司新闻' },
      { id: 'exhibition', name: '展会动态' },
      { id: 'industry', name: '行业动态' },
    ],
    items: [
      { title: '中泽科技发布新一代教育机器人套件，引领STEM教育新潮流' },
      { title: '人工智能进校园：如何通过编程教育提升学生逻辑思维能力' },
      { title: '2023年度全国青少年机器人大赛圆满落幕，中泽支持战队斩获佳绩' },
      { title: '探索未来教育：数字化转型背景下的智慧教室建设方案' },
      { title: '中泽科技与多所高校达成战略合作，共建人工智能联合实验室' },
    ],
  },

  home: {
    banner: {
      item1: {
        title: '创客教育',
        desc: '提供了实验和探索的空间，促进了学生的全面发展',
      },
      item2: {
        title: '开启智慧之门',
        desc: '从激光设备应用，到套件课程学习，全方位满足不同学习需求。',
      },
      item3: {
        title: '套件课程',
        desc: '人工智能ISTEAM教育|科创教育 课程提效必备',
      },
    },
    resources: {
      title: '丰富的STEM教学资源',
      tabs: {
        laser: {
          name: '激光切割机',
          title: '激光设备',
          desc1: '桌面智能激光切割雕刻机',
          desc2: '高精度切割│智能便捷操作│高效加工│安全环保',
        },
        software: {
          name: '软件',
          title: '科教软件',
          desc1: '多方位全能软件',
          desc2: '云平台 | 学习平台 | Light Maker',
        },
        ai: {
          name: 'AI智能教学辅助',
          title: '智能教学辅助',
          desc1: '实时监控与设备预警',
          desc2: 'AI助教助手 | 可视化看板',
        },
        kits: {
          name: '套件与课程',
          title: '丰富课程套件',
          desc1: 'PBL项目式学习',
          desc2: '配套教材 | 动手实践',
        },
      },
    },
    different: {
      title: '与众不同的我们',
      items: {
        solution: { title: '教育AI解决方案', desc: '提升教学效果和学习体验' },
        course: { title: '创意思维课程', desc: '课程适合3-16岁的少年儿童' },
        product: { title: '科创教育产品', desc: '一键激光造物' },
        space: { title: '创客探索空间', desc: '创新与实用性相结合' },
      },
    },
    creative: {
      title: '创意驱动，造物未来',
      machineDesc: '智能桌面式激光切割&雕刻机器',
      lightBlue530Desc: '智能蓝光激光切割&雕刻机器',
      markM20Desc: '高精度激光打标机',
      light640Desc: '专业台式激光切割&雕刻机器',
    },
    innovation: {
      title: '如何促进创新学习？',
      desc: '中泽科教致力于开发高品质的科创教育产品，包括激光切割机等。这些产品助力学生在科学、技术、工程、艺术和数学等领域开展实践学习。',
      items: {
        steam: 'STEAM',
        coding: '编程',
        light530: '使用Light 530',
        robotics: '机器人技术',
      },
    },
    bottomBanner: {
      title: '让AI教育落地',
      subtitle: 'AI+教育数智化赋能，融合创新理念',
      desc: '专注激光定制化产品和技术服务，助力院校&企业融合【AI+教育】',
    },
  },
  software: {
    laserSoftware: {
      bannerTitle: '激光设备专用软件  Light Maker',
      bannerDesc: '专业激光设备软件，简单高效，专注切割与雕刻体验。',
      bannerImageAlt: 'Light Maker 界面',
      creationTitle: '让创作变得简单',
      features: {
        proDesignTool: '专业级设计工具',
        highPrecisionParams: '高精度参数设置',
        multiDeviceControl: '多设备管理控制',
        assetLibrary: '强大的素材库管理系统',
      },
      intro: {
        imageAlt: '功能展示',
        items: {
          item1: {
            title: '功能强大易于使用的设计系统',
            desc: '强大的创作软件，兼容JPG、DXF、AI、DST、PNG、BMP、TIF、SVG格式的高质量设计。',
          },
          item2: {
            title: '专业性',
            desc: '专业的画图功能，满足一切制作需求。无论是复杂的设计还是简单的切割，都能轻松应对。',
          },
        },
      },
      downloadTitle: '软件下载',
      downloadButton: '下载体验',
      downloadApps: {
        lightMakerApp: 'LightMaker App',
        laserMakerLightSystem: 'LaserMaker Light System',
      },
    },
    learningPlatform: {
      bannerTitle: '中泽科教学习平台',
      bannerDescLine1:
        '中泽科教学习平台是一个创新的在线学习工具，旨在为学生和教师提供一个全面的科教软件解决方案。',
      bannerDescLine2:
        '无论是在移动设备还是电脑上，用户都可以轻松访问和使用我们的平台。',
      bannerImageAlt: '中泽科教学习平台界面',
      exploreTitle: '探索无限可能，创造精彩未来',
      exploreTabs: [
        { name: '制作' },
        { name: '新手入门' },
        { name: '建模学习' },
        { name: '一键制作' },
        { name: 'AI生图' },
      ],
      tabContentAlt: '功能展示',
      introTitle: '创新学习平台',
      introItems: [
        {
          title: '高效学习新体验',
          desc: '中泽科教学习平台一站式整合课程学习、图形设计与激光切割功能，卡片化界面简洁直观，操作便捷流畅，让创意设计到实物制作无缝衔接，高效易上手。',
        },
        {
          title: '智能便捷，新手无忧',
          desc: '内置海量图库与智能参数预设，一键即可制作，新手秒速上手；手机端详尽的引导教程，让入门零压力；云端实时监控设备状态，全程守护教学安全。',
        },
      ],
      introImageAlt: '创新学习平台',
      galleryAlt: '平台展示',
      downloadTitle: '软件下载',
      downloadApps: [{ name: '中泽科教平台App' }, { name: '中泽设计软件PC版' }],
      downloadButtonText: '下载体验',
    },
    cloudPlatform: {
      bannerTitle: '中泽科教云平台',
      bannerDesc:
        '一站式教育管理工具，支持作业收发、设备监控、报修及参数配置，助力教师、学生和学校高效管理。',
      bannerImageAlt: '中泽科教云平台界面',
      exploreTitle: '简化教学管理',
      exploreTabs: [
        { name: '学生端' },
        { name: '教师端' },
        { name: '代理商端' },
      ],
      tabContentAlt: '功能展示',
      introTitle: '提升教育效率',
      introItems: [
        {
          title: '操作便利',
          desc: '一键制作：内置图库和参数配置，支持一键制作，简化操作流程。设备监控：实时监控设备状态，确保教学活动顺利进行。',
        },
        {
          title: '统一管理',
          desc: '设备并联：支持创客教室其他设备并联，一键管理功能，提高管理效率。',
        },
        {
          title: '实时监控',
          desc: '设备状态：实时了解设备的运行状态，出现故障及时报修。维护保养：系统根据设备运行时长和使用频率，定期提示进行维护保养，延长设备使用寿命，提高切割质量。',
        },
      ],
      introImageAlt: '创新学习平台',
      galleryTitle: '让AI教育落地',
      galleryDesc: 'AI+教育数智化赋能，融合创新理念',
    },
  },
  eduServices: {
    banner: {
      title: 'AI+教育',
      desc: '中泽教育数智化教学解决方案，助力国家培养创新人才，以教育发展和学生需求为导向，为K-12学校提供全学段AI教育方案。',
      imageAlt: '教育解决方案Banner',
    },
    recommended: {
      title: '推荐产品',
      products: [
        { name: 'Light 640', alt: 'Light 640' },
        { name: 'Light 530', alt: 'Light 530' },
        { name: 'Mark M20', alt: 'Mark M20' },
        { name: 'Light Blue 530', alt: 'Light Blue 530' },
      ],
    },
    solutionCategories: {
      title: '打造全能教学空间',
      tabs: {
        'teaching-assist': '智能教学辅助',
        'process-optimize': '教学流程优化',
        'device-manage': '设备管理',
      },
      tabContents: {
        'teaching-assist': {
          title: '智能教学辅助',
          features: ['·实时监控与设备物资', '·AI智能养学助手', '·可视化看板'],
        },
        'process-optimize': {
          title: '教学流程优化',
          features: ['·线上作业下发与批改', '·远程集中管控课程云资源'],
        },
        'device-manage': {
          title: '设备管理',
          features: ['·教育设备实时监控', '·远程设备报修'],
        },
      },
      categories: [
        {
          title: '线上下发作业与批改作业',
          description: '智能化的作业管理系统，提高教学效率',
        },
        { title: '远程设备报修', description: '便捷的远程设备维护和报修服务' },
        {
          title: '远程集中管控,简化教学流程',
          description: '统一的远程管理平台，优化教学流程',
        },
        { title: '课程云资源', description: '丰富的云端课程资源和教学素材' },
        {
          title: '教育设备实时监控',
          description: '实时监控设备状态，确保教学顺利进行',
        },
        { title: 'AI智能教学助手', description: 'AI驱动的智能教学辅助系统' },
      ],
      solutionCards: [
        { title: '科创数智化方案' },
        { title: '中小学智能教室方案' },
        { title: '中高职技能方案' },
        { title: '大学AI教室方案' },
      ],
    },
    solutions: {
      title: '一站式教育解决方案',
      items: [
        {
          title: '设备',
          description:
            '在AI赋能教育的背景下，恒好激光切割机通过智能云平台支持，与中泽科教激光教学云平台深度联动，教师可远程管理设备、分发任务并追踪学生进度。这种融合不仅提升了教学效率，还为学生提供了更个性化的学习体验。',
          buttonText: '查看详细 →',
        },
        {
          title: '软件',
          description:
            '中泽教育平台融合AI技术，提供个性化学习、智能工具、互动体验和云端资源，支持课程、作业管理，设备监控预警及数据分析。搭配中泽学习平台（APP/PC）和Light Maker工具，全方位助力教学，优化资源，推动教育创新，为师生和教育机构提供强大支持。',
          buttonText: '查看详细 →',
        },
        {
          title: '课程',
          description:
            '中泽教育科创切割课程，专为青少年设计的系统化、模块化课程，激发兴趣与潜能。涵盖科技知识、创新思维、项目实践和科学实验，助力孩子成为未来科创人才，推动社会发展。',
          buttonText: '查看详细 →',
        },
      ],
    },
    managementPlatform: {
      title: '中泽教育智慧教学管理平台',
      desc: '提供个性化的学习路径、智能教学工具、互动式学习体验和云端资源库，支持课程管理、学生进度追踪、在线作业、教学设备实时监控与预警，数据分析等功能。通过融合 AI 技术，提升教学效果，实现教育资源的优化配置，为学生、教师、学校和教育机构提供全方位的教育支持，共同推动教育的发展和创新。',
      items: [
        { title: '科创数智化方案', alt: '科创数智化方案' },
        { title: '中小学智能教室方案', alt: '中小学智能教室方案' },
        { title: '中高职技能方案', alt: '中高职技能方案' },
        { title: '大学AI教室方案', alt: '大学AI教室方案' },
      ],
      action: {
        text: '获取专属解决方案',
        alt: '联系我们图标',
      },
    },
  },
  makerK12: {
    banner: {
      title: '科教创客—中小学',
    },
    intro: {
      title: '教育和学校中的激光切割机',
      desc: '在学校中使用激光切割机，从创意到成品都是安全、无接触和数字化的。轻松实现孩子们的奇思妙想。',
      imageAlt: '建筑模型制作中的激光切割机',
    },
    scenesFeatured: {
      title: '利用尖端教育工具改变学习方式',
      desc: '为学生提供行业领先的技术，以提高创造力、批判性思维和技术技能。',
    },
    scenes: {
      items: [
        {
          title: '为每一个学生提供激光创作平台',
          desc: '践行理念，训练学生的参与能力，让学生能够借助强大的工具在课堂上培养创造性思维。',
        },
        {
          title: '电子及编程套件',
          desc: '利用交互式套件让学生参与动手编程 、机器人技术和人工智能。',
        },
        {
          title: '职业技术教育',
          desc: '用激光技术平台铺就职业道路和提升技能，以适应不断变化的就业市场，创造更多机会。',
        },
      ],
    },
    solutions: {
      title: '建筑模型广泛应用于众多领域',
      items: [
        { title: 'K12学校/学区' },
        { title: '培训机构' },
        { title: '研究实验室&专业课程' },
        { title: '创客空间' },
        { title: '建筑装图书馆/博物馆' },
        { title: '创意课程' },
      ],
    },
    bannerLeft: {
      title: '让AI教育落地',
      subtitle: 'AI+教育数智化赋能，融合创新理念',
    },
    products: {
      tabs: [
        {
          title: '激光设备',
          title1: '造物神器 - 激光切割机',
          description:
            'Light530和640采用一流的零部件，高质量的生产工艺和严格的检验流程集合而成的一台高性能、稳定性强、切割雕刻精准的强大激光机，完美融合科创教育应用场景的激光创作需求。',
        },
        {
          title: '软件',
          title1: '绘图能手 -LightMaker',
          description:
            '为学生提供安全、速度、智能功能和市场上最具创新性的技术设计。LightMaker，兼容多种设计软件，包括 AI、PS、CorelDRAW、AutoCAD、Solidworks等，支持上传高质量的 JPG、DXF、AI、DST、PNG、BMP、TIF、SVG 等文件。',
        },
        {
          title: '课程',
          title1: '多元教学 - 科创教育课程',
          description:
            '我们深知，每个孩子都是独一无二的，因此我们的课程设计灵活多样，旨在激发每位学生的兴趣和潜能。课程内容包括但不限于:科技基础知识、创新思维训练、项目实践、科学实验等。',
        },
      ],
    },
    learning: {
      title: '如何在课堂学习中运用中泽科教激光切割机?',
      teacher: {
        title: '教师',
        lines: [
          '制作课程教具与教材附件',
          '激光切割机可协助教师高效率产出教具与课堂附件，更能为教师创造出更新颖的教学模式。',
        ],
      },
      student: {
        title: '学生',
        lines: [
          '培养实践技能',
          '在课堂中，激光切割机扮演着陪伴学生学习设计、工程、科技等跨领域的角色，协助学生将脑海中的想象付诸实现。',
        ],
      },
    },
    carousel: {
      items: [
        { alt: '建筑模型制作场景1' },
        { alt: '建筑模型制作场景2' },
        { alt: '建筑模型制作场景3' },
      ],
    },
  },
  archVocational: {
    banner: {
      title: '建筑模型-中职',
    },
    intro: {
      title: '激光切割机如何用于建筑模型制作？',
      desc: '您可以使用激光切割和雕刻建筑模型制作以及玩具行业模型制作中的最小部件。 能快速而精确地激光切割纺织品、塑料、木材、贴面板、MDF、PMMA、纸板、纸张、泡沫、聚苯乙烯、薄膜、亚克力等等。',
      imageAlt: '建筑模型制作中的激光切割机',
    },
    scenesFeatured: {
      title: '建筑模型制作的革新力量',
      desc: '协助您完成精细微缩样品与高品质建筑模型，将您的创意蓝图精致呈现。',
    },
    scenes: {
      items: [
        {
          title: '高精度',
          desc: '激光切割机能够以极高的精度切割材料，误差可控制在极小范围内，确保建筑模型的各个部件尺寸精准，完美契合设计图纸的要求。',
        },
        {
          title: '多样化材料',
          desc: '木材的自然质感、亚克力的透明与光泽、纸张的轻盈与可塑性，都能通过激光切割雕刻展现出独特的魅力。',
        },
        {
          title: '复杂形状处理能力强',
          desc: '对于建筑模型中常见的复杂几何形状和精细细节，激光切割能够轻松实现，如曲线、异形结构等，为模型制作提供了更大的创意空间。',
        },
      ],
    },
    solutions: {
      title: '建筑模型广泛应用于众多领域',
      items: [
        { title: '教育与学术研究应用' },
        { title: '模型制作与玩具行业' },
        { title: '装饰元素与建筑特色' },
        { title: '房地产与城市规划' },
        { title: '建筑装饰与装修' },
      ],
    },
    bannerLeft: {
      title: '让AI教育落地',
      subtitle: 'AI+教育数智化赋能，融合创新理念',
    },
    products: {
      tabs: [
        {
          title: ' 合适的设备',
          title1: '选择合适的设备',
          description:
            '激光设备能够将学生的想法快速转化为实物，无论是模型制作、设计还是艺术创作，都能轻松实现。从简单的手工制作到复杂的机械设计，激光切割机和雕刻机能够精准地完成任务，让学生在实践中学习和成长。 ',
        },
        {
          title: '自行设计',
          title1: '自行设计',
          description:
            '直观地修改设计并预览最终效果。在各种材料上切割和复制任何设计的细节：使用文本、徽标、图像或照片优化您的艺术品。可以快速装饰您的建筑模型。',
        },
        {
          title: '你的市场',
          title1: '提升学生技能',
          description:
            '便携式激光打标机，适合建筑模型的标记和细节雕刻。操作简单，携带方便，是建筑教学的必备工具。',
        },
      ],
    },
    learning: {
      title: '多学科课程教学',
      groups: [
        {
          title: '微缩模型',
          lines: [
            '准确、细致，满足微缩创作的需求',
            '在多种材质上精致呈现激光雕刻/切割细节，省去繁琐流程、体验高效创作并减少手工误差。',
          ],
        },
        {
          title: '室内设计',
          lines: [
            '设计细节一次到位,内建相机轻松预览物件位置、大小，所见即所得。有效执行切割/雕刻工作并减少材料损耗。',
          ],
        },
      ],
    },
    carousel: {
      items: [
        { alt: '建筑模型制作场景1' },
        { alt: '建筑模型制作场景2' },
        { alt: '建筑模型制作场景3' },
      ],
    },
  },
  artsUniversity: {
    banner: {
      title: '艺术与工艺品-高校',
    },
    intro: {
      title: '如何使用激光设备加工艺术品和工艺品',
      desc: '该设备为学生提供了将创意转化为实物的平台，激发了他们的创新思维和创造力。学生可以设计出各种独特的模型、艺术品等，如激光剪纸、印章等。',
      imageAlt: '艺术与工艺品加工中的激光设备',
    },
    scenesFeatured: {
      title: '技术技能培养',
      desc: '学生通过操作激光切割雕刻机，可以学习到关于材料科学和加工技术的深入知识，提高动手能力和问题解决能力。',
    },
    scenes: {
      items: [
        {
          title: '创意思维激发',
          desc: '激光切割雕刻机可以被用于实现学生的创意设计，如制作模型、艺术品等，增强学生的创造力。',
        },
        {
          title: '多学科融合',
          desc: '激光切割雕刻技术涉及到多个学科的知识，如物理、化学、材料科学、计算机科学等。在高校教学中，可以促进不同学科之间的交叉融合，培养学生的综合素养。',
        },
        {
          title: '实践教学项目',
          desc: '激光切割雕刻技术可用于高校的实践教学项目，如工程训练、艺术设计、文化创意等。例如，学生可以利用激光切割雕刻机制作建筑模型、机械零部件、艺术雕塑等，将理论知识与实践操作相结合。',
        },
      ],
    },
    solutions: {
      title: '在高校工艺品制作中的应用',
      items: [
        { title: '定制零售品' },
        { title: '礼品个性化' },
        { title: '节日营销' },
        { title: '珠宝配饰' },
        { title: '个性化服装' },
      ],
    },
    bannerLeft: {
      title: '让AI教育落地',
      subtitle: 'AI+教育数智化赋能，融合创新理念',
    },
    products: {
      tabs: [
        {
          title: ' 合适的设备',
          title1: '选择合适的设备',
          description:
            '通过选择合适的激光切割雕刻设备，高校可以为学生提供先进的实践教学工具，激发他们的创造力，同时提高教学质量和效率。',
        },
        {
          title: '自行设计',
          title1: '自行设计',
          description:
            '直观地修改设计并预览最终效果。在各种材料上雕刻和复制任何设计的细节：使用文本、徽标、图像或照片优化您的艺术品。激光雕刻机操作非常简单易用；能快速装饰您的艺术品。',
        },
        {
          title: '艺术与设计',
          title1: '艺术与设计专业教学',
          description:
            '在艺术设计、工业设计等专业中，激光切割雕刻机被广泛应用于课程设计和毕业设计项目中。学生可以利用激光切割雕刻机将设计想法快速转化为实物作品，训练产品原型开发能力。',
        },
      ],
    },
    learning: {
      title: '让激光走进学校',
      groups: [
        {
          title: '精准高效，省时省力',
          lines: [
            '中泽激光切割机支持相机预览，精准对位不耗材，新手也能轻松上手。',
            '使用流畅简单，放入材料即可创意设计，所见即所得。',
            '精准创作，善用每块材料，省时省力省材料。',
          ],
        },
        {
          title: '高功率性能，多元材质轻松应对',
          lines: [
            '搭载高功率CO₂激光器，雕刻切割样样行。',
            '可轻松切割和雕刻亚克力、木材、竹子等多元材质，为手作爱好者建立友善创作流程，让创作更简单高效。',
          ],
        },
      ],
    },
    carousel: {
      items: [{ alt: '艺术与工艺品制作场景1' }],
    },
  },
  cultHigherVoc: {
    banner: {
      title: '文创设计—高职',
    },
    intro: {
      title: '文创设计中的激光设备',
      desc: '高职院校的文创设计专业通常配备先进的激光切割雕刻设备，如激光雕刻机等，这些设备能够满足学生在不同阶段的实践教学需求。',
      imageAlt: '文创设计中的激光设备',
    },
    scenesFeatured: {
      title: '开启创意与品质的无限可能',
      desc: '它以其卓越的性能和精准的切割能力，成为文创设计师们手中不可或缺的得力工具。',
    },
    scenes: {
      items: [
        {
          title: '高精度切割，完美呈现设计细节',
          desc: '对于文创设计中那些复杂精细的图案和独特的造型，激光切割机能够完美地将其还原，确保每一个细节都精准无误地呈现在最终产品上。',
        },
        {
          title: '多样化材质加工',
          desc: '激光设备能够处理多种材质，如木材、亚克力、皮革、金属等，为文创产品的设计提供了丰富的材料选择。',
        },
        {
          title: '智能化操作，简化创意实现过程',
          desc: '学生们只需将设计好的图案输入到计算机中，激光切割机就能自动识别并进行精确切割。这种智能化的操作方式不仅降低了对操作人员专业技能的要求，还提高了生产过程的稳定性和可靠性。',
        },
      ],
    },
    solutions: {
      title: '让更多好设计走入生活',
      items: [
        { title: '文化主题装饰画' },
        { title: '创意灯具设计' },
        { title: '家居摆件与饰品' },
        { title: '笔筒与文具收纳盒' },
        { title: '民族风饰品' },
        { title: '旅游纪念品' },
      ],
    },
    bannerLeft: {
      title: '让AI教育落地',
      subtitle: 'AI+教育数智化赋能，融合创新理念',
    },
    learning: {
      title: '高职文创设计中的生产工具',
      groups: [
        {
          title: '个性化定制',
          lines: [
            '激光切割雕刻机能够轻松实现照片、名字或特殊图案的个性化定制，满足消费者对于独特、有纪念意义的礼品的需求。',
            '例如，可以在木质摆件、皮革饰品和亚克力装饰品等文创产品上雕刻出消费者指定的图案或文字，使其更具个性化。',
          ],
        },
        {
          title: '文创衍生品制作',
          lines: [
            '从博物馆的文创纪念品到电影、动漫的衍生产品，激光切割雕刻机让复杂设计变得可视化、可商品化。',
            '它可以将名胜古迹、地标建筑、文化IP等元素转化为现实产品，如将一张普通的木板切割成具有独特图案和形状的装饰品，将一张普通的纸张雕刻成精美的艺术品。',
          ],
        },
        {
          title: 'DIY创作',
          lines: [
            '激光设备正在助力手工爱好者实现更高水平的DIY创作，从小型工艺品到独特的家居装饰，都可以通过激光技术快速实现。',
          ],
        },
      ],
    },
    carousel: {
      items: [
        { alt: '文创设计场景1' },
        { alt: '文创设计场景2' },
        { alt: '文创设计场景3' },
      ],
    },
  },
  eduCooperation: {
    banner: {
      title: '教育合作',
    },
    advantages: {
      title: '我们的合作优势',
      items: [
        {
          title: '经验丰富的研发团队',
          desc: '中泽科教拥有一支由工程师和 STEM 教育工作者组成的专业团队，不断开发符合高教育标准并吸引学生的创新产品。',
        },
        {
          title: 'AI+教育数智化赋能',
          desc: '中泽教育智慧平台：个性化学习、智能工具、互动体验，支持课程管理、进度追踪、作业提交，设备监控与数据分析，云端资源丰富，教学更高效。',
        },
        {
          title: '丰富的套件与课程体系',
          desc: '我们提供从初级到高级的激光切割、智能家居、智能交通等课程，满足不同年龄段学生的需求。',
        },
      ],
    },
    modes: {
      title: '合作模式',
      carouselAlts: ['教育合作场景', '教育合作课堂', '教育合作实践'],
      items: [
        {
          title: '课程引进',
          desc: '合作机构可以直接引进我们的课程体系，快速提升教学质量。',
        },
        {
          title: '套件',
          desc: '套件专为3-16岁儿童设计，通过安全、易于操作的实验材料，激发孩子们对科学、技术、工程、艺术和数学（STEAM）的兴趣。',
        },
        {
          title: '产品合作',
          desc: '合作机构可以采购我们的教育产品，如激光切割机，用于教学和学生实践。',
        },
        {
          title: '联合研发',
          desc: '我们欢迎合作机构参与课程和产品的研发，共同推动教育创新。',
        },
      ],
    },
    bottomBanner: {
      lines: ['让AI教育落地', 'AI+教育数智化赋能，融合创新理念'],
    },
  },
  support: {
    downloadCenter: {
      bannerTitle: '下载中心',
      sectionTitle: '软件下载',
      downloadButtonText: '下载客户端',
      softwareList: [
        { name: 'Light maker App' },
        { name: 'Good-laser Light maker' },
        { name: '中泽科教学习平台app' },
        { name: '中泽科教学习平台' },
      ],
    },
    afterSales: {
      bannerTitle: '售后服务',
      serviceTitle: 'AR智能服务',
      serviceItems: [
        {
          title: '远程诊断',
          desc: 'AR远程指导：技术支持团队实时查看设备状态，快速诊断故障，提供精准解决建议。',
        },
        {
          title: '虚拟维修',
          desc: 'AR操作演示：虚拟展示维修步骤，直观易懂，助您轻松掌握方法。',
        },
        {
          title: '智能教程',
          desc: 'AR互动学习：设备上直接查看操作指南，高效又便捷。',
        },
        {
          title: '快速响应',
          desc: 'AR即时支持：快速响应，减少等待，问题解决更高效。',
        },
      ],
      videosTitle: '操作视频',
      playButtonText: '播放视频',
      videos: [
        { title: '拆包装视频演示' },
        { title: '设备通讯连接的方式' },
        { title: 'Light 530 使用教程' },
        { title: '开箱安装教程' },
        { title: '软件基本操作' },
        { title: '常见故障排查' },
      ],
      manualsTitle: '操作说明书',
      viewPdfButtonText: '查看PDF文件',
      manuals: [
        { title: 'Light 530操作说明' },
        { title: 'Light 640操作说明' },
        { title: 'Blue 530使用手册' },
        { title: 'M20维护指南' },
        { title: '激光切割安全手册' },
      ],
    },
  },

  product: {
    kits: {
      bannerTitle: '三大套件系列',
      bannerDesc:
        '套件支持个性化学习，适应不同年龄段和学习需求的学生，同时为教师提供丰富的教学资源和工具，帮助他们更有效地进行教学和指导。',
      sections: {
        educationTitle: '教育套件',
        educationDesc: '培养创新思维和创造力',
        creativityTitle: '创意驱动，造物未来',
        projectsTitle: '多样化的教育项目',
      },
      kitsTabs: [
        {
          name: '激光切割入门套件',
          title: '激光切割入门套件\n(配套木板耗材)',
          desc: '激光切割STEAM课程，依据多元智能理论、STEAM教育理念及项目式学习理论设计，针对不同年龄段学生，培养创新能力、批判性思维、问题解决能力，以及沟通与团队协作精神。 ',
        },
        {
          name: '奇妙科学宝盒',
          title: '奇妙科学宝盒\n(配套木板+微电路套件包)',
          desc: '课程紧扣《义务教育科学课程标准（2022年版）》，围绕科学观念、科学思维、探究实践、态度责任四维度，培养学生核心素养。每节课完成一个科学作品，涵盖传统技艺、技术工程与社会等核心概念，引导学生像科学家一样思考，提升探究能力，构建科学思维。',
        },
        {
          name: '人工智能编程套件',
          title: '人工智能编程套件',
          desc: '探索未来科技，从人工智能编程套件开始。智能农场、智能家居、智能交通、智能工厂套件，分别带学生了解农业科技、体验现代生活、探索交通效率、揭示智能制造。动手实践激发创新思维，培养解决问题能力，助力迎接智能世界。',
        },
      ],
      creativityItems: [
        {
          title: '增强实践能力',
          desc: '这些套件融合STEMA（科学、技术、工程、艺术、数学）教育，通过动手操作和项目实践，全面提升学生实践能力和解决问题的能力。',
        },
        {
          title: '培养创新思维',
          desc: '鼓励学生创新设计与实验，培养创新思维和创造力。在团队项目中，提升沟通与协作能力。。',
        },
        {
          title: '教师教学辅助',
          desc: '鼓励学生创新设计与实验，培养创新思维和创造力。在团队项目中，提升沟通与协作能力。',
        },
      ],
      projectItems: [
        { title: '科学' },
        { title: '技术' },
        { title: '编程' },
        { title: '艺术' },
      ],
      bottomBannerText:
        '课程通过动手操作和项目实践，增强学生实践能力，解决实际问题；培养创新思维和创造力，鼓励创新设计与实验。团队项目提升沟通协作能力，学习合作。接触最新技术和工具，助力学生适应未来社会需求。',
    },
    courses: {
      bannerTitle: '课程体系',
      bannerDesc:
        '为不同年龄段学生设计的系统化STEAM课程，融合科学、技术、工程、艺术和数学，培养未来创新人才。',
      bannerAlt: '课程体系',
      bottomBannerAlt: '课程体系课程展示',
      sections: {
        kitsTitle: '课程套件',
        kitsDesc: '配套硬件与软件的完美结合',
        seriesTitle: '精品课程系列',
      },
      courseTabs: [
        {
          name: '年龄3-6岁',
          title: '科学探索体系-幼儿 （6门课）',
          desc: '通过生活中常见的现象，利用科学教具进一步探索，从而了解事物发展的规律和原理。',
        },
        {
          name: '年龄6-12岁',
          title: 'STEAM创客体系青少年（3门课）',
          desc: '发挥自己的创意，能够运用设备，动手实践，将创意转化成作品。',
        },
        {
          name: '年龄8-13岁',
          title: '激光切割课程体系（3门课）',
          desc: '能利用设备切割不同的结构件，组装成立体的结构，并对结构进行美化。编程能力：了解编程判断的逻辑与原理。',
        },
        {
          name: '年龄6-15岁',
          title: '人工智能课程体系（4门课）',
          desc: '使用设备工具，设计制作作品的外观，并通过编程使作品变得智能化、简单化，并能解决生活中遇到的问题。编程能力：了解编程判断的逻辑与原理 学习Arduino的编程语法。',
        },
      ],
      introItems: [
        {
          title: '实践操作性强',
          desc: '课程设计重实践，学生动手操作激光切割机等设备，将理论转化为实操技能。',
        },
        {
          title: '创新思维培养',
          desc: '课程鼓励学生创意设计与制作，培养创新思维和问题解决能力。',
        },
        {
          title: '项目驱动学习',
          desc: '课程采用项目驱动的学习方式，通过完成具体的项目任务，学生可以在实践中学习和掌握知识。',
        },
        {
          title: '科技前沿探索',
          desc: '项目驱动学习，学生在完成具体项目任务中实践学习，掌握知识。',
        },
        {
          title: '系统化教学',
          desc: '课程从初级到中级逐步深入，系统化教授激光切割技术，助力学生构建扎实知识体系。',
        },
        {
          title: '趣味性与挑战性并存',
          desc: '课程设计兼具趣味与挑战，激发学生学习兴趣与探索欲。',
        },
      ],
      courseListRow1: [{ name: '智能农场' }, { name: '智能家居' }],
      courseListRow2: [{ name: '智能交通' }, { name: '智能工厂' }],
      bottomBannerText:
        '课程以实践操作、创新思维和跨学科融合为特色，采用项目驱动学习，让学生在趣味与挑战中掌握前沿科技。结合系统化教学、安全教育和个性化学习，培养动手能力、团队合作精神和问题解决能力，鼓励成果展示，增强学生成就感。',
    },
    kitsAccessories: {
      bannerTitle: '套件配件',
      accessories: [
        { name: 'RGB灯带' },
        { name: 'DS1307时钟模块' },
        { name: 'DHT11温湿度传感器' },
        { name: '人体感应传感器' },
        { name: 'LED照明模块' },
        { name: '风扇模块' },
        { name: '槽型光耦开关' },
        { name: '按键模块' },
        { name: '掌控板' },
        { name: '拓展版' },
        { name: '雨滴传感器' },
        { name: 'TT马达带转接板' },
        { name: '红外感应模块' },
        { name: '红外遥控' },
        { name: '气体' },
        { name: '四位数码管模块' },
        { name: '矩阵键盘' },
        { name: '光敏传感器' },
        { name: '红绿灯模块' },
        { name: '蜂鸣器' },
      ],
    },
    light530: {
      name: 'Light 530',
      bannerTitle: '智能桌面式激光切割 & 雕刻机器',
      sections: {
        advantages: '我们的优势',
        aiTitle: '让AI教育落地',
        aiSubtitle: 'AI+教育数智化赋能，融合创新理念',
        carouselTitle: '用光雕刻的无限可能',
        specsTitle: '产品规格参数',
      },
      bannerFeatures: [
        '定点拍摄 / 描摹图形 / 安全防护',
        '专为STEAM教育和创客而研发',
      ],
      softwareSection: {
        title: '操作简单且功能强大的激光切割系统',
        items: [
          '可针对不同的加工材料设置不同的加工工艺参数，如：切割、深雕、浅雕、扫描等。',
          '丰富的图纸素材，提高使用者的设计效率。',
          '摄像头支持定点拍摄、辅助设计图形，让创意变为现实。',
        ],
      },
      advantages: [
        {
          tagTitle: '高品质高精度激光',
          desc: '如原装进口二氧化碳激光管，波长10640nm，提供55W连续激光功率。最大切割厚度可达20mm（亚克力）。工作速度达1000mm/s，重复定位精度0.025mm。确保精准，可快速精准地切割和雕刻出精致的创意作品。',
        },
        {
          tagTitle: '一体化三重废气过滤系统',
          desc: '过滤网，活性炭和UV臭氧层的多种烟尘过滤系统风箱一体化设计的构造，不仅更清洁环保，同时放置产品也更便捷和紧凑，无需另外单独购买过滤箱和占用更多空间。',
        },
        {
          tagTitle: '最高优先级安全防护',
          desc: '通过SGS实验室最高安全测试，FDA认证的I类激光产品，有独 特的安全及工作状态指示灯设计，可直观、清晰的掌握机器的 运行状态。',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        leftSpecs: [
          { label: '激光器类型', value: '密封式二氧化碳玻璃激光管' },
          { label: '激光头升降行程', value: '≤25mm' },
          { label: '可放置材料厚度', value: '≤22mm' },
          { label: '对焦方式', value: '自动对焦，手动对焦' },
          { label: '连接方式', value: '支持USB连接、网线连接、WIFI连接' },
          { label: '支持操作系统', value: 'Windows、iOS' },
          {
            label: '支持设计软件',
            value: 'Ps, Ai, CorelDRAW, AutoCAD, Solidworks等',
          },
          {
            label: '支持文件格式',
            value: 'JPG, DXF, AI, DST, PNG, BMP, TIF, SVG等',
          },
          { label: '激光器使用寿命', value: '≤9000小时' },
          {
            label: '软件操作系统',
            value: 'LightMaker(电脑端&移动端), Lightburn(电脑端)',
          },
          { label: '操作控制方式', value: '5寸LCD触摸屏/手机APP/PC端软件' },
          { label: '机器工作噪音', value: '≤60db' },
          { label: '传动形式', value: '高速步进电机+高精密直线导轨+同步皮带' },
          {
            label: '安全防护',
            value:
              '联锁开关开盖即停，弹撞即停，紧急按钮，安全钥匙，工作状态指示灯，水箱高温报警',
          },
          { label: '供电系统', value: '230V/110VAC 50HZ/60HZ' },
          { label: '机器重量', value: '≈70kg' },
        ],
        waterCoolingSpecs: [
          { label: '冷却方式', value: '内置水冷系统（活性水）' },
          { label: '工作电压', value: '直流24V风冷+铝盘管' },
          { label: '水箱容量', value: '3.2L' },
          { label: '最大扬程', value: '5M' },
          {
            label: '水流量',
            value: '1000L/H或外置专用CW3000型激光专用冷水机（可选）',
          },
        ],
        airPumpSpecs: [
          { label: '排气量', value: '50L/min' },
          { label: '噪音', value: '≤48dB' },
          { label: '气压', value: '≥0.05Mpa' },
        ],
        exhaustSpecs: [
          { label: '额定功率', value: '62W' },
          { label: '风量', value: '280m³/H' },
          { label: '噪音', value: '≤50dB' },
          { label: '电压', value: 'AC 220V/110V' },
        ],
        groups: {
          waterCoolingTitle: '水冷系统参数（内置）',
          airPumpTitle: '气泵参数（内置）',
          airPumpValueOnly: '交流220V/110V 16W',
          exhaustTitle: '吸风系统参数（外置连体）侧下抽风',
          filterTitle: '过滤系统',
          filterValue: '活性炭过滤棉+静音风扇+工业级活性炭板',
        },
      },
    },
    lightbule530: {
      name: 'Light Blue 530',
      bannerTitle: '智能蓝光激光切割&雕刻机器',
      sections: {
        advantages: '我们的优势',
        aiTitle: '让AI教育落地',
        aiSubtitle: 'AI+教育数智化赋能，融合创新理念',
        carouselTitle: '用光雕刻的无限可能',
        specsTitle: '产品规格参数',
      },
      bannerFeatures: ['多材质可加工', '自信地创作，随时都可以轻松创作'],
      advantages: [
        {
          tagTitle: '外观占地面积',
          desc: '蓝光雕刻机造型时尚、现代、紧凑，适合摆放在任何家庭、学校或工作室空间。金属机身搭配亚克力盖子的精妙组合使你清楚看到加工材料的过程。',
        },
        {
          tagTitle: '封闭式加工，隔离避免伤害',
          desc: '蓝光雕刻机是全封闭式的，如果在执行任务时打开盖子，它会自动暂停。如果发生紧急情况，只需一个开关即可立即关闭机器。适合家庭和学校使用。',
        },
        {
          tagTitle: '多材质加工，支持上百种加工材料',
          desc: '定制任何独特形状或风格的动态产品系列，添加配件以实现更多不同形状的材料雕刻，如杯子和圆形物体，非常适合您的小型企业需求。',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        groups: {
          waterCoolingTitle: '冷却系统',
          airPumpTitle: '气泵参数',
          airPumpValueOnly: '—',
          exhaustTitle: '排气系统',
          filterTitle: '过滤系统',
          filterValue: '—',
        },
        left: [
          { key: 'laserType', label: '激光类型', value: '蓝光激光' },
          { key: 'laserPower', label: '激光器功率', value: '20W / 40W' },
          { key: 'maxCutThickness', label: '最大切割厚度', value: '≤10mm' },
          { key: 'focusMode', label: '对焦方式', value: '手动对焦' },
          { key: 'connection', label: '连接方式', value: 'USB 连接' },
          {
            key: 'os',
            label: '支持操作系统',
            value: 'Windows / Android / iOS',
          },
          {
            key: 'softwareOS',
            label: '软件操作系统',
            value: 'LightBurn（电脑端）',
          },
          {
            key: 'laserLifetime',
            label: '激光器使用寿命',
            value: '≥10000 小时',
          },
          {
            key: 'maxMaterialThickness',
            label: '可放置材料厚度',
            value: '20mm',
          },
          { key: 'noise', label: '机器工作噪音', value: '≤60dB' },
          { key: 'engraveSpeed', label: '雕刻速度', value: '600mm/s' },
          {
            key: 'designSoftware',
            label: '支持设计软件',
            value: 'Ps, Ai, CorelDRAW, AutoCAD, Solidworks 等',
          },
        ],
        water: [],
        air: [],
        exhaust: [],
        right: [
          { key: 'maxSpeed', label: '最大工作速度', value: '600mm/s' },
          {
            key: 'power',
            label: '供电系统',
            value: '230V / 110V AC 50Hz / 60Hz',
          },
          { key: 'workTable', label: '工作平台尺寸', value: '520 × 315mm' },
          { key: 'accuracy', label: '定位精度', value: '±0.01mm' },
          { key: 'repeatAccuracy', label: '重复定位精度', value: '±0.005mm' },
          {
            key: 'powerRequirement',
            label: '电源要求',
            value: 'AC 220V ±10%，50Hz',
          },
          { key: 'totalPower', label: '整机功率', value: '300W' },
          {
            key: 'transmission',
            label: '传动形式',
            value: '高速步进电机 + 高精密直线导轨 + 同步皮带',
          },
          {
            key: 'safety',
            label: '安全防护',
            value: '锁开关盖即停、弹轴限位、紧急按钮、安全钥匙',
          },
          { key: 'weight', label: '机器重量', value: '≈50kg' },
          { key: 'machineSize', label: '机器尺寸', value: '805 × 585 × 320mm' },
        ],
      },
    },
    lightm20: {
      name: 'Mark M20',
      bannerTitle: '高精度激光打标机',
      sections: {
        advantages: '我们的优势',
        aiTitle: '让AI教育落地',
        aiSubtitle: 'AI+教育数智化赋能，融合创新理念',
        carouselTitle: '激光打标，创意定制',
        specsTitle: '产品规格参数',
      },
      bannerFeatures: [
        '安全保障，双开关控制，激光防护',
        '具备高精度、高速度、高稳定性的雕刻与切割能力',
      ],
      advantages: [
        {
          tagTitle: '多样化应用场景',
          desc: '该设备适用于多种行业，包括珠宝雕刻、个性化物件、零件识别等，能满足从珠宝、香水瓶到小型工业标牌等各种用途的定制雕刻。',
        },
        {
          tagTitle: '教育领域的创新应用',
          desc: 'Mark M20设备将工业级精度引入教育领域，"成为科创教育的“全能助手”，培养学生从基础打标技能到复杂项目开发的能力。',
        },
        {
          tagTitle: '紧凑与现代化',
          desc: 'Mark M20激光打标机设计紧凑现代，占地面积小，噪音低，视窗大，满足高耐用性需求。其时尚外观符合安全标准，适用于教育机构、公共零售环境。',
        },
        {
          tagTitle: '数秒内完成打标',
          desc: 'Mark M20即使是选用最小的字体，也能在几秒钟内完成精确打标。这种无与伦比的速度与我们的激光应用软件LightMaker简化后的工作流程和效率相结合，可确保您的生产率得到显著提高。 ',
        },
      ],
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      specs: {
        groups: {},
        left: [
          { key: 'laserType', label: '激光器类型', value: '光纤激光器' },
          { key: 'laserPower', label: '激光功率', value: '20W / 30W / 50W' },
          {
            key: 'markArea',
            label: '标记区域',
            value: '标准 110×110mm（可通过更换不同场镜扩展，如 175×175mm 等）',
          },
          { key: 'maxHeight', label: '最大工作高度', value: '≤130mm' },
          { key: 'connection', label: '连接方式', value: '以太网' },
          {
            key: 'os',
            label: '支持操作系统',
            value: 'Windows / iOS / Android',
          },
          {
            key: 'power',
            label: '供电系统',
            value: '230V / 110V AC 50Hz / 60Hz',
          },
          {
            key: 'safety',
            label: '安全防护',
            value: '开关开盖即停、弹轴限位、紧急按钮、安全钥匙',
          },
          { key: 'software', label: '支持软件', value: 'Mantimark' },
        ],
        water: [],
        air: [],
        exhaust: [],
        right: [
          {
            key: 'transmission',
            label: '传动形式',
            value: '打标头高精密电动螺杆升降',
          },
          {
            key: 'fileFormat',
            label: '支持的文件',
            value: 'SVG / DXF / JPG / JPEG / PNG / BMP / TIF',
          },
          { key: 'spotSize', label: '聚焦光斑直径', value: '≤20μm' },
        ],
      },
    },
    light640: {
      name: 'Light 640',
      bannerTitle: '智能台式激光切割&雕刻机器',
      sections: {
        advantages: '我们的优势',
        aiTitle: '让AI教育落地',
        aiSubtitle: 'AI+教育数智化赋能，融合创新理念',
        carouselTitle: '创意切割，从这里开始',
        specsTitle: '产品规格参数',
      },
      bannerFeatures: [
        '快速 / 开放式后门 / 高效自动对焦',
        '一体全能型激光雕刻切割机',
      ],
      models: [
        { id: 'light640', name: 'Light 640' },
        { id: 'light960', name: 'Light 960' },
        { id: 'light1390', name: 'Light 1390' },
        { id: 'light1610', name: 'Light 1610' },
      ],
      advantages: [
        {
          tagTitle: '工作区域',
          desc: '出色的切割和雕刻作品，多种机型，多种激光功率配置，满足不同应用的需求\n激光类型：直流CO2\n激光功率：60W-130W\nLight640（600*400mm）\nLight960（900*600mm）\nLight1390（1300*900mm）\nLight1610（1600*1000mm）',
        },
        {
          tagTitle: '高效自动对焦+红点定位',
          desc: '自动对焦功能可以在切割和雕刻前快速准确对焦并定位。加上红点定位的光束，可实时查看工作位置。这样，为您节省了大量的切割和雕刻时间，并为您带来更好的切割和雕刻效果。',
        },
        {
          tagTitle: '开放式后门设计',
          desc: '开放式后门的设计允许放置无限制长度的切割和雕刻材料，600mm×∞长度的板材使您的工作更加方便，受到的限制更少。',
        },
      ],
      advantagesByModel: {
        light960: [
          {
            tagTitle: '出色的切割和雕刻作品',
            desc: '激光切割机搭载高精度的激光切割平台，对木材和亚克力等材料的加工已达到企业级加工标准与效率，能够批量生产激光工艺产品，助力企业生产力与品牌效能飞跃提升。',
          },
          {
            tagTitle: '搭载优质激光管与精密组件',
            desc: '多样化的产品线，可根据客户需求选择不同的激光类型和加工强度，满足各类生产要求，为木材、玻璃、亚克力等材料和工艺提供了更广泛的应用。',
          },
          {
            tagTitle: '严苛光品质量测试，品质保证',
            desc: '开通产线严格测试，精确的光路控制和超过5次的切割和雕刻测试确保激光具有稳定一致输出的顶级CO2激光管。凭借出色的功率稳定性和精细的激光光斑，可实现均匀的雕刻，甚至可雕刻出复杂的细节。',
          },
        ],
        light1390: [
          {
            tagTitle: '出色的切割和雕刻作品',
            desc: '激光切割机搭载高精度的激光切割平台，对木材和亚克力等材料的加工已达到企业级加工标准与效率，能够批量生产激光工艺产品，助力企业生产力与品牌效能飞跃提升。',
          },
          {
            tagTitle: '搭载优质激光管与精密组件',
            desc: '多样化的产品线，可根据客户需求选择不同的激光类型和加工强度，满足各类生产要求，为木材、玻璃、亚克力等材料和工艺提供了更广泛的应用。',
          },
          {
            tagTitle: '严苛光品质量测试，品质保证',
            desc: '开通产线严格测试，精确的光路控制和超过5次的切割和雕刻测试确保激光具有稳定一致输出的顶级CO2激光管。凭借出色的功率稳定性和精细的激光光斑，可实现均匀的雕刻，甚至可雕刻出复杂的细节。',
          },
        ],
        light1610: [
          {
            tagTitle: '全面&先进的安全功能',
            desc: '1. 紧急停止\n2. 报警灯\n3. 防水开关\n4. 接地线\n5. 内置热探测器警报在机器异常活动时自动开启\n6. 锁盖保护\n7. 钢化玻璃材质耐用保护窗',
          },
          {
            tagTitle: '经久耐用，品质卓越',
            desc: '1. 非常适合单件项目或大规模生产。\n2. 工作区域选择范围广，从 600 x 400MM 到 1600 x 1000MM。\n3. 无与伦比的雕刻速度。\n4. 行业专家设计。\n5. 是个性化、教育和工业应用的理想之选。',
          },
          {
            tagTitle: '通过智能监控优化生产',
            desc: '专为保护您最昂贵的设备组件（轴、激光头、光学元件、镜头）免受灰尘和污垢侵蚀而设计，即使在大量使用的情况下，也能确保多年无故障运行。',
          },
        ],
      },
      carouselTitles: [
        'Project 1',
        'Project 2',
        'Project 3',
        'Project 4',
        'Project 5',
        'Project 6',
      ],
      carouselByModel: {
        light640: {
          title: 'Light 640，能用来做什么',
          items: [
            {
              title: 'Light 640 - 项目 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 640 - 项目 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 640 - 项目 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 640 - 项目 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 640 - 项目 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 640 - 项目 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 640 - 项目 6',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 640 - 项目 6',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light960: {
          title: 'Light 960，能用来做什么',
          items: [
            {
              title: 'Light 960 - 项目 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 960 - 项目 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 960 - 项目 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 960 - 项目 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 960 - 项目 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 960 - 项目 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 960 - 项目 6',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 960 - 项目 6',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light1390: {
          title: 'Light 1390，能用来做什么',
          items: [
            {
              title: 'Light 1390 - 项目 1',
              image: require('../../assets/product/530-1.png'),
            },
            {
              title: 'Light 1390 - 项目 2',
              image: require('../../assets/product/530-2.png'),
            },
            {
              title: 'Light 1390 - 项目 3',
              image: require('../../assets/product/530-3.png'),
            },
            {
              title: 'Light 1390 - 项目 4',
              image: require('../../assets/product/530-4.png'),
            },
            {
              title: 'Light 1390 - 项目 5',
              image: require('../../assets/product/530-5.png'),
            },
            {
              title: 'Light 1390 - 项目 6',
              image: require('../../assets/product/530-6.png'),
            },
            {
              title: 'Light 1390 - 项目 6',
              image: require('../../assets/product/530-7.png'),
            },
            {
              title: 'Light 1390 - 项目 6',
              image: require('../../assets/product/530-8.png'),
            },
          ],
        },
        light1610: {
          title: 'Light 1610，能用来做什么',
          items: [
            {
              title: 'Light 1610 - 项目 1',
              image: require('@/assets/product/1610-1.png'),
            },
            {
              title: 'Light 1610 - 项目 2',
              image: require('@/assets/product/1610-2.png'),
            },
            {
              title: 'Light 1610 - 项目 3',
              image: require('@/assets/product/1610-3.png'),
            },
            {
              title: 'Light 1610 - 项目 4',
              image: require('@/assets/product/1610-4.png'),
            },
            {
              title: 'Light 1610 - 项目 5',
              image: require('@/assets/product/1610-5.png'),
            },
            {
              title: 'Light 1610 - 项目 6',
              image: require('@/assets/product/1610-6.png'),
            },
            {
              title: 'Light 1610 - 项目 6',
              image: require('@/assets/product/1610-7.png'),
            },
            {
              title: 'Light 1610 - 项目 6',
              image: require('@/assets/product/1610-8.png'),
            },
          ],
        },
      },
      specs: {
        groups: {
          waterCoolingTitle: '冷却系统',

          exhaustTitle: '排气系统',
        },
        left: [
          { key: 'model', label: '设备型号', value: 'Light 640' },
          { key: 'workArea', label: '加工幅面', value: '600mm × 400mm' },
          {
            key: 'laserType',
            label: '激光类型',
            value: '密封式 CO₂ 玻璃激光管',
          },
          {
            key: 'laserPower',
            label: '激光功率',
            value: '60W / 80W / 100W',
          },
          {
            key: 'zAxis',
            label: 'Z 轴高度',
            value: '135mm（5.3 英寸）',
          },
          {
            key: 'tableSize',
            label: '工作台尺寸',
            value: '700 × 530mm（27.6″ × 20.9″）',
          },
          {
            key: 'maxMaterialFrontBack',
            label: '最大材料尺寸（前后门关闭）',
            value: '700 × 530 × 170mm（27.6″ × 20.9″ × 6.7″）',
          },
          {
            key: 'maxMaterialOpen',
            label: '最大材料尺寸（后门打开）',
            value: '700 × ∞ × 20mm（27.6″ × ∞ × 0.8″）',
          },
          {
            key: 'machineSize',
            label: '机器尺寸（宽 × 长 × 高）',
            value: '1450 × 950 × 1180mm（57.1″ × 37.4″ × 46.5″）',
          },
          {
            key: 'weight',
            label: '机器重量',
            value: '300kg（660 磅）',
          },
          {
            key: 'maxSpeed',
            label: '最大工作速度',
            value: '1000mm/s',
          },
          {
            key: 'accuracy',
            label: '定位精度',
            value: '0.01mm – 0.05mm',
          },
          {
            key: 'focusMode',
            label: '对焦模式',
            value: '自动对焦 / 手动对焦',
          },
          {
            key: 'resume',
            label: '断电后继续雕刻',
            value: '支持',
          },
          {
            key: 'transmission',
            label: '传动形式',
            value: '高速步进电机 + 高精密闭环电机',
          },
          {
            key: 'connection',
            label: '通讯方式',
            value: 'LAN 网线 / USB / WiFi',
          },
        ],
        right: [
          {
            key: 'software',
            label: '软件',
            value: 'Good-Laser LightMaker（适配 LightBurn）',
          },
          {
            key: 'process',
            label: '加工工艺',
            value: '线描、切割、深雕、浅雕',
          },
          {
            key: 'fileFormats',
            label: '支持的文件格式',
            value: '位图：JPG / PNG / BMP；矢量：LPC / DXF / PLT / SVG',
          },
          {
            key: 'frequency',
            label: '频率',
            value: '50 / 60Hz',
          },
          {
            key: 'phase',
            label: '阶段',
            value: '单相',
          },
          {
            key: 'current',
            label: '满负载电流',
            value: '6A',
          },
          {
            key: 'voltage',
            label: '电压',
            value: '230V 交流电',
          },
          {
            key: 'totalPower',
            label: '总功率',
            value: '≤ 1.5kW',
          },
          {
            key: 'materials',
            label: '适用材料',
            value:
              '木材、亚克力、皮革、布料、塑料、纸板、橡胶、双色板、大理石、玻璃、阳极氧化铝及其他非金属材料',
          },
          {
            key: 'safety',
            label: '安全标准',
            value:
              '符合欧盟 CE 安全标准，具备工作舱开盖保护、冷保护系统、温度控制自动报警系统、漏电线路保护系统、紧急停止保护系统、光路系统、钢化玻璃观察系统、工作状态指示灯等',
          },
        ],
        water: [
          {
            key: 'coolingMode',
            label: '冷却方式',
            value: '水冷',
          },
        ],

        exhaust: [
          {
            key: 'exhaustDiameter',
            label: '排气口直径',
            value: '150mm',
          },
        ],
      },
      modelSpecOverrides: {
        light960: {
          model: 'Light 960',
          workArea: '900mm × 600mm',
          laserType: '密封式 CO₂ 玻璃激光管',
          laserPower: '80W / 100W / 120W',
          zAxis: '135mm（5.3 英寸）',
          tableSize: '1000 × 730mm（39.4″ × 28.7″）',
          maxMaterialFrontBack: '1000 × 730 × 170mm（39.4″ × 28.7″ × 9.0″）',
          maxMaterialOpen: '1000 × ∞ × 20mm（39.4″ × ∞ × 0.8″）',
          machineSize: '1500 × 1200 × 1180mm（59.1″ × 47.5″ × 45.5″）',
          weight: '410kg（902 磅）',
          maxSpeed: '1000mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: '自动对焦 / 手动对焦',
          resume: '支持',
          transmission: '高速步进电机 + 高精密闭环电机',
          connection: 'LAN 网线 / USB / WiFi',
          software: 'Good-Laser LightMaker（适配 LightBurn）',
          process: '线描、切割、深雕、浅雕',
          fileFormats: '位图：JPG / PNG / BMP；矢量：LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: '单相',
          current: '6A',
          voltage: '230V 交流电',
          totalPower: '≤ 1.5kW',
          materials:
            '木材、亚克力、皮革、布料、塑料、纸板、橡胶、双色板、大理石、玻璃、阳极氧化铝及其他非金属材料',
          safety:
            '符合欧盟 CE 安全标准，具备工作舱开盖保护、水冷保护系统、温度控制自动报警系统、漏电线路保护系统、紧急停止保护系统、光路系统、钢化玻璃观察系统、工作状态指示灯等',
          coolingMode: '水冷',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
        light1390: {
          model: 'Light 1390',
          workArea: '1300mm × 900mm',
          laserType: '密封式 CO₂ 玻璃激光管',
          laserPower: '100W / 130W / 150W',
          zAxis: '135mm（5.3 英寸）',
          tableSize: '1370 × 900mm（53.4″ × 35.5″）',
          maxMaterialFrontBack: '1370x900x135mm(53.4"x35.5"x5.4")',
          maxMaterialOpen: '1370 × ∞ × 30mm（54.0″ × ∞ × 1.2″）',
          machineSize: '1860 × 1450 × 1200mm（73.3″ × 57.1″ × 46.5″）',
          weight: '500kg（1100 磅）',
          maxSpeed: '600mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: '自动对焦 / 手动对焦',
          resume: '支持',
          transmission: '高速步进电机 + 高精密闭环电机',
          connection: 'LAN 网线 / USB / WiFi',
          software: 'Good-Laser LightMaker（适配 LightBurn）',
          process: '线描、切割、深雕、浅雕',
          fileFormats: '位图：JPG / PNG / BMP；矢量：LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: '单相',
          current: '6A',
          voltage: '230V 交流电',
          totalPower: '≤ 1.5kW',
          materials:
            '木材、亚克力、皮革、布料、塑料、纸板、橡胶、双色板、大理石、玻璃、阳极氧化铝及其他非金属材料',
          safety:
            '符合欧盟 CE 安全标准，具备工作舱开盖保护、水冷保护系统、温度控制自动报警系统、漏电线路保护系统、紧急停止保护系统、光路系统、钢化玻璃观察系统、工作状态指示灯等',
          coolingMode: '水冷',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
        light1610: {
          model: 'Light 1610',
          workArea: '1600mm × 1000mm',
          laserType: '密封式 CO₂ 玻璃激光管',
          laserPower: '110W / 130W / 150W',
          zAxis: '135mm（5.3 英寸）',
          tableSize: '1700 × 1130mm（66.9″ × 44.5″）',
          maxMaterialFrontBack: '1700 × 1130 × 170mm',
          maxMaterialOpen: '1700 × ∞ × 20mm',
          machineSize: '2200 × 1500 × 1180mm',
          weight: '590kg（1298 磅）',
          maxSpeed: '1000mm/s',
          accuracy: '0.01mm – 0.05mm',
          focusMode: '自动对焦 / 手动对焦',
          resume: '支持',
          transmission: '高速步进电机 + 高精密闭环电机',
          connection: 'LAN 网线 / USB / WiFi',
          software: 'Good-Laser LightMaker（适配 LightBurn）',
          process: '线描、切割、深雕、浅雕',
          fileFormats: '位图：JPG / PNG / BMP；矢量：LPC / DXF / PLT / SVG',
          frequency: '50 / 60Hz',
          phase: '单相',
          current: '6A',
          voltage: '230V 交流电',
          totalPower: '≤ 1.5kW',
          materials:
            '木材、亚克力、皮革、布料、塑料、纸板、橡胶、双色板、大理石、玻璃、阳极氧化铝及其他非金属材料',
          safety:
            '完全符合欧盟 CE 安全标准，具备开盖保护、水冷保护、温度报警、漏电保护、紧停及激光闭路系统',
          coolingMode: '水冷',
          airPump: '—',
          exhaustDiameter: '150mm',
        },
      },
    },
  },

  footer: {
    subscribe: {
      placeholder: '您的电子邮箱地址',
      button: '订阅',
    },
    social: {
      tiktok: '抖音',
      weibo: '视频号',
      wechat: '微信',
      redbook: '小红书',
    },
    companyDesc:
      '专注于3-16岁少年儿童的科技创造力教育，开设科创教育空间，自主研发科创教育产品与课程，围绕学习设计软件、激光雕刻、编程等内容板块。',
    navColumns: [
      {
        title: '产品',
        items: [
          { label: '设备', to: '/product/light530' },
          { label: '套件', to: '/product/kits' },
          { label: '课程', to: '/product/courses' },
        ],
      },
      {
        title: '软件',
        items: [
          { label: '中泽科教云平台', to: '/software/cloud-platform' },
          { label: '中泽科教学习平台', to: '/software/learning-platform' },
          { label: 'Light Maker', to: '/software/laser-software' },
        ],
      },
      {
        title: '教育服务',
        items: [
          { label: 'AI教育解决方案', to: '/edu-services' },
          { label: '科教创客-中小学', to: '/edu-services/maker-k12' },
          {
            label: '建筑模型-中职',
            to: '/edu-services/architectural-vocational',
          },
          {
            label: '文创设计-高职',
            to: '/edu-services/cultural-higher-vocational',
          },
          { label: '艺术与工艺品-高校', to: '/edu-services/arts-university' },
          { label: '科创空间', to: '/edu-services' },
        ],
      },
      {
        title: '服务与支持',
        items: [
          { label: '下载中心', to: '/support/download' },
          { label: '售后服务', to: '/support/after-sales' },
        ],
      },
      {
        title: '教育合作',
        items: [{ label: '教育合作', to: '/edu-services/cooperation' }],
      },
      {
        title: '关于我们',
        items: [
          { label: '关于我们', to: '/about' },
          { label: '新闻资讯', to: '/about/news' },
        ],
      },
    ],
    contact: {
      phone: '销售热线：18379276683',
      email: '邮箱：sam@zz-steam.com',
      address: '地址：深圳福田八卦四路华晟达大厦A座',
    },
    qrDesc: '了解更多',
  },

  globalContactForm: {
    title: '联系我们',
    subtitle: '请填写以下表单，我们会尽快与您联系',
    fields: {
      name: '姓名',
      email: '邮箱',
      phone: '电话',
      company: '公司',
      message: '留言',
    },
    placeholders: {
      name: '请输入您的姓名',
      email: '请输入您的邮箱',
      phone: '请输入您的电话',
      company: '请输入您的公司名称',
      message: '请输入您的留言内容',
    },
    submitting: '提交中...',
    submit: '提交',
    visual: {
      title: '期待与您的合作',
      description: '我们提供专业的服务与支持，如有任何疑问请随时联系。',
    },
    contact: {
      phone: '联系电话',
      email: '联系邮箱',
    },
    validation: {
      name: '请输入姓名',
      email: '请输入邮箱',
      emailFormat: '请输入正确的邮箱格式',
      phone: '请输入电话号码',
      phoneFormat: '请输入有效的电话号码',
      message: '请输入留言内容',
    },
    success: '提交成功！我们会尽快联系您。',
    networkError: '提交失败，请稍后重试。',
  },
};
